
import BANNER_LINE_SMALL from "@/assets/images/V2/banner-line-small.png";
import { IS_NOT_SPONSOR } from "@/constants/banner";
import { defineComponent } from "vue-demi";

export default defineComponent({
  name: "Banner",
  props: {
    /**
     * Banner title text
     */
    title: {
      type: String,
      default:
        "To hire international employees, you'll first need a Sponsor Licence. Start your application now.",
    },
    /**
     * Banner description text (supports HTML)
     */
    text: {
      type: String,
      default: "",
    },
    /**
     * Button label text
     */
    buttonLabel: {
      type: String,
      default: "Open",
    },
    /**
     * Function to execute when button is clicked
     */
    action: {
      type: Function,
      default: null,
    },
  },
  emits: ["action", "button-click"],
  setup(props, { emit }) {
    const handleButtonClick = () => {
      if (props.action) {
        props.action();
      }
      emit("action", IS_NOT_SPONSOR, props.buttonLabel);
      emit("button-click", IS_NOT_SPONSOR, props.buttonLabel);
    };

    return {
      BANNER_LINE_SMALL,
      handleButtonClick,
    };
  },
});
